import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import reducers from '@app/store/reducers';
import rootSaga from '@app/store/sagas';

const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer: reducers,
  middleware: [...getDefaultMiddleware({thunk: false}), sagaMiddleware],
});

sagaMiddleware.run(rootSaga);

export default store;
